module.exports = __webpack_public_path__ + "static/media/pick_entry_0e2c37_150.7b29e7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/pick_entry_0e2c37_150.png
// module id = 580
// module chunks = 0